import { useState, useCallback } from "react";
import { getMaintenance } from "../api/base";

export function useMaintenance() {
  const [maintenance, setMaintenance] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const checkMaintenance = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await getMaintenance();
      setMaintenance(data.data?.maintenance || false);
      setMessage(data.message || "");
    } catch (error) {
      setMaintenance(false);
      setMessage("");
    }
    setLoading(false);
  }, []);

  return {
    maintenance,
    message,
    loading,
    checkMaintenance,
  };
}
